const RIGHTS_CHECKOUT_AS_CLIENT = 'checkout_as_client'
export { RIGHTS_CHECKOUT_AS_CLIENT }
